import ExternalDeliveryFileDownload from '@components/file-download/external-delivery';

const ExternalDeliveryFileDownloadPage = () => {
  return <ExternalDeliveryFileDownload />;
};

export default ExternalDeliveryFileDownloadPage;
